import { getUserId, postRenewSession } from "@/api/adapter.api";
import { setTokens } from "../token-operators.usecase";
import { logout as logoutApi } from "@/api/adapter.api";
import { PortalAdapterApi } from "@vacancorp/portal.adapter.api";

export async function isValidUser(): Promise<boolean> {
  try {
    const user: { userId: number } = await getUserId();
    return user.userId > 0;
  } catch (err) {
    return false;
  }
}

export async function logout() {
  // Logout directly regardless to tokens and do not popup login UI when refresh/access tokens are expired on logout access
  await logoutApi().catch(() => true);
  setTokens(undefined, undefined);
}

export async function renewSessionService(): Promise<boolean> {
  try {
    const result: PortalAdapterApi.ResponsePostLogin | undefined = await postRenewSession();
    if (result === undefined || result.accessToken === "") {
      throw new Error("Failed to renew token");
    }
    setTokens(result.accessToken, result.refreshToken);
    return true;
  } catch {
    setTokens(undefined, undefined);
    return false;
  }
}
